export const allFilters = [
  { title1: 'Challenge', title2: 'CHALLENGE', typeNo: 2 },
  { title1: 'Change Referee', title2: 'CHANGE_REFEREE', typeNo: 27 },
  { title1: 'Change Server', title2: 'CHANGE_SERVER', typeNo: 33 },
  { title1: 'Check Connection', title2: 'CHECK_CONNECTION', typeNo: 28 },
  { title1: 'Coin Toss', title2: 'COIN_TOSS', typeNo: 3 },
  { title1: 'Collect Rally Statistic', title2: 'COLLECT_RALLY_STATISTIC', typeNo: 29 },
  { title1: 'Court arrival', title2: 'COURT_ARRIVAL', typeNo: 25 },
  { title1: 'Equipment Timeout', title2: 'EQUIPMENT_TIMEOUT', typeNo: 1 },
  { title1: 'Forfeit', title2: 'FORFEIT', typeNo: 5 },
  { title1: 'Game Over', title2: 'GAME_OVER', typeNo: 4 },
  { title1: 'Match Over', title2: 'MATCH_OVER', typeNo: 6 },
  { title1: 'Medical Timeout', title2: 'MEDICAL_TIMEOUT', typeNo: 7 },
  { title1: 'Missed Serve', title2: 'MISSED_SERVE', typeNo: 8 },
  { title1: 'Move Players', title2: 'MOVE_PLAYERS', typeNo: 32 },
  { title1: 'Penalty', title2: 'PENALTY', typeNo: 9 },
  { title1: 'Players On Court', title2: 'PLAYERS_ON_COURT', typeNo: 10 },
  { title1: 'Point', title2: 'POINT', typeNo: 14 },
  { title1: 'Point In Progress', title2: 'POINT_IN_PROGRESS', typeNo: 12 },
  { title1: 'Point Replay', title2: 'POINT_REPLAY', typeNo: 11 },
  { title1: 'Retirement', title2: 'RETIREMENT', typeNo: 13 },
  { title1: 'Serve Selection', title2: 'SERVE_SELECTION', typeNo: 15 },
  { title1: 'Side Out', title2: 'SIDE_OUT', typeNo: 16 },
  { title1: 'Start Scoring', title2: 'START_SCORING', typeNo: 22 },
  { title1: 'Statistic', title2: 'STATISTIC', typeNo: 26 },
  { title1: 'Suspension', title2: 'SUSPENSION', typeNo: 21 },
  { title1: 'Switch Ends', title2: 'SWITCH_ENDS', typeNo: 17 },
  { title1: 'Second Server', title2: 'SWITCH_SERVER', typeNo: 23 },
  { title1: 'Time In', title2: 'TIME_IN', typeNo: 24 },
  { title1: 'Time Violation', title2: 'TIME_VIOLATION', typeNo: 19 },
  { title1: 'Timeout', title2: 'TIME_OUT', typeNo: 18 },
  { title1: 'Undo', title2: 'UNDO', typeNo: 31 },
  { title1: 'Warming Up', title2: 'WARMING_UP', typeNo: 20 },
  { title1: 'Withdrawal', title2: 'WITHDRAWAL', typeNo: 30 },
  { title1: 'Other', title2: 'UNDEFINED_LOG_REFERENCE_TYPE', typeNo: 0 },
];
